// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

import {
  footerPDFTextColor,
  footerBackGroundColor,
  footerTextColor,
} from "../config/const";

const Footer = () => {
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);
  const pdfDatas = useAtomValue(AppAtoms.pdfDatas);
  return (
    <>
      {layoutConfig.site_color === "" ? (
        <></>
      ) : (
        <footer>
          <div className="footer-image">
            <img src={layoutConfig.header_location_logo} alt="ロゴ2" />
          </div>
          <ul>
            {pdfDatas.map((pdfData) => {
              if (pdfData.site_pdf_footer == "表示") {
                return (
                  <li>
                    <a
                      href={pdfData.header_location_pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: footerPDFTextColor[layoutConfig.site_color],
                      }}
                    >
                      {pdfData.site_pdf_name}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
          {layoutConfig.site_footer !== "" ? (
            <div
              className="footer-text"
              style={{
                backgroundColor: footerBackGroundColor[layoutConfig.site_color],
                color: footerTextColor[layoutConfig.site_color],
              }}
            >
              {layoutConfig.site_footer}
            </div>
          ) : null}
        </footer>
      )}
    </>
  );
};

export default Footer;
